export default "__VITE_ASSET__0w87n5Az__"